import { render, staticRenderFns } from "./total-seats.vue?vue&type=template&id=5807328d&"
import script from "./total-seats.vue?vue&type=script&lang=js&"
export * from "./total-seats.vue?vue&type=script&lang=js&"
import style0 from "./total-seats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports